
export function storage_get_me() {
    return JSON.parse(localStorage.getItem("me"))
}